import { render, staticRenderFns } from "./PerSearch.vue?vue&type=template&id=2ea340ff&scoped=true"
import script from "./PerSearch.vue?vue&type=script&lang=js"
export * from "./PerSearch.vue?vue&type=script&lang=js"
import style0 from "./PerSearch.vue?vue&type=style&index=0&id=2ea340ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea340ff",
  null
  
)

export default component.exports